
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M14 47.06H4M12 38.06H0M14 29.06H4M35.29 9.38v6.95M40.38 9.38v6.95"}}),_c('circle',{attrs:{"cx":"37.83","cy":"36.87","r":"20.88","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M37.83 25.28v11.59l7.94-7.12M42.12 8.36a3.06 3.06 0 100-6.11h-8.58a3.06 3.06 0 100 6.11zM23 22.86l-2.28-3.38a1.82 1.82 0 01.07-2.48l2.39-1.61c.65-.44 1.7 0 2.33.89l2.27 3.38M52.72 22.9L55 19.52a1.83 1.83 0 00-.09-2.52l-2.45-1.65a1.83 1.83 0 00-2.37.86l-2.27 3.39"}})])
          )
        }
      }
    